import { t } from "../../i18n";

export function getSeoQuickLinks() {
  return [
    { title: t("homeQuickLink1Title"), body: t("homeQuickLink1Body"), to: "/products" },
    { title: t("homeQuickLink2Title"), body: t("homeQuickLink2Body"), to: "/custom-service" },
    { title: t("homeQuickLink3Title"), body: t("homeQuickLink3Body"), to: "/custom-service" },
    { title: t("homeQuickLink4Title"), body: t("homeQuickLink4Body"), to: "/contact" },
    { title: t("homeQuickLink5Title"), body: t("homeQuickLink5Body"), to: "/products" },
    { title: t("homeQuickLink6Title"), body: t("homeQuickLink6Body"), to: "/solutions" }
  ];
}

export function getSeoScenarios() {
  return [
    {
      title: t("homeScenario1Title"),
      body: t("homeScenario1Body"),
      image: "/assets/solutions/scenario-studio-starter.jpg",
      to: "/solutions"
    },
    {
      title: t("homeScenario2Title"),
      body: t("homeScenario2Body"),
      image: "/assets/solutions/scenario-retail-display.jpg",
      to: "/solutions"
    },
    {
      title: t("homeScenario3Title"),
      body: t("homeScenario3Body"),
      image: "/assets/solutions/scenario-online-bundle.jpg",
      to: "/solutions"
    }
  ];
}

export function getSeoProcessSteps() {
  return [
    t("homeProcessStep1"),
    t("homeProcessStep2"),
    t("homeProcessStep3"),
    t("homeProcessStep4"),
    t("homeProcessStep5"),
    t("homeProcessStep6"),
    t("homeProcessStep7")
  ];
}

export function getBlogHighlights() {
  return [
    {
      title: t("homeBlogHighlight1Title"),
      body: t("homeBlogHighlight1Body")
    },
    {
      title: t("homeBlogHighlight2Title"),
      body: t("homeBlogHighlight2Body")
    },
    {
      title: t("homeBlogHighlight3Title"),
      body: t("homeBlogHighlight3Body")
    }
  ];
}

export function getSeoFaqFallbackItems() {
  return [
    {
      id: "faq-fallback-1",
      question: t("homeFallbackFaq1Question"),
      answer: t("homeFallbackFaq1Answer")
    },
    {
      id: "faq-fallback-2",
      question: t("homeFallbackFaq2Question"),
      answer: t("homeFallbackFaq2Answer")
    },
    {
      id: "faq-fallback-3",
      question: t("homeFallbackFaq3Question"),
      answer: t("homeFallbackFaq3Answer")
    },
    {
      id: "faq-fallback-4",
      question: t("homeFallbackFaq4Question"),
      answer: t("homeFallbackFaq4Answer")
    },
    {
      id: "faq-fallback-5",
      question: t("homeFallbackFaq5Question"),
      answer: t("homeFallbackFaq5Answer")
    },
    {
      id: "faq-fallback-6",
      question: t("homeFallbackFaq6Question"),
      answer: t("homeFallbackFaq6Answer")
    },
    {
      id: "faq-fallback-7",
      question: t("homeFallbackFaq7Question"),
      answer: t("homeFallbackFaq7Answer")
    },
    {
      id: "faq-fallback-8",
      question: t("homeFallbackFaq8Question"),
      answer: t("homeFallbackFaq8Answer")
    }
  ];
}

export function getSeoKeywordBody() {
  return t("homeSeoKeywordBody");
}
